import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var LocationWmsService = /** @class */ (function () {
    function LocationWmsService(http) {
        this.http = http;
        this.baseUrl = environment.wmsUrl;
    }
    LocationWmsService.prototype.getAll = function (countryCode, sorting, skipCount, maxResultCount) {
        var url_ = this.baseUrl + "/api/services/app/Location/GetAll?";
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return this.http.get(url_)
            .pipe(map(function (x) { return x.result ? x.result : null; }));
    };
    LocationWmsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LocationWmsService_Factory() { return new LocationWmsService(i0.ɵɵinject(i1.HttpClient)); }, token: LocationWmsService, providedIn: "root" });
    return LocationWmsService;
}());
export { LocationWmsService };
var ProductLocationWmsService = /** @class */ (function () {
    function ProductLocationWmsService(http) {
        this.http = http;
        this.baseUrl = environment.wmsUrl;
    }
    ProductLocationWmsService.prototype.get = function (nro) {
        var url = this.baseUrl + "/api/services/app/ProductLocation/Get?id=" + nro;
        return this.http.get(url)
            .pipe(map(function (x) { return x.result ? x.result : null; }));
    };
    ProductLocationWmsService.prototype.create = function (dto) {
        var url = this.baseUrl + "/api/services/app/ProductLocation/create";
        return this.http.post(url, dto)
            .pipe(map(function (x) { return x.result ? x.result : null; }));
    };
    ProductLocationWmsService.prototype.update = function (dto) {
        var url = this.baseUrl + "/api/services/app/ProductLocation/update";
        return this.http.put(url, dto)
            .pipe(map(function (x) { return x.result ? x.result : null; }));
    };
    return ProductLocationWmsService;
}());
export { ProductLocationWmsService };
var LocationDtoResult = /** @class */ (function () {
    function LocationDtoResult() {
    }
    return LocationDtoResult;
}());
export { LocationDtoResult };
var LocationDto = /** @class */ (function () {
    function LocationDto() {
    }
    return LocationDto;
}());
export { LocationDto };
var ProductLocationDto = /** @class */ (function () {
    function ProductLocationDto() {
    }
    return ProductLocationDto;
}());
export { ProductLocationDto };
